// Angular
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
// Service
import { ThemeModeService, ThemeModeType } from '../services';
// Module
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-theme-mode-switch',
  templateUrl: './theme-mode-switch.component.html',
  styleUrls: ['./theme-mode-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, InlineSVGModule, TranslocoDirective],
})
export class ThemeModeSwitchComponent implements OnInit {
  // Private
  private themeModeService = inject(ThemeModeService);

  // Public
  mode: ThemeModeType;

  /**
   * On Init
   * @memberof ThemeModeSwitchComponent
   */
  ngOnInit(): void {
    this.mode = this.themeModeService.mode();
  }

  /**
   * Switch theme mode
   * @param {ThemeModeType} mode
   * @memberof ThemeModeSwitchComponent
   */
  switchMode(mode: ThemeModeType): void {
    this.mode = mode;
    this.themeModeService.mode.set(mode);
  }

  /**
   * Get Theme Icon
   * @param {string} mode
   * @returns {string}
   * @memberof ThemeModeSwitchComponent
   */
  getThemeIcon(mode: string): string {
    return mode === 'light'
      ? './assets/media/icons/duotune/general/gen060.svg'
      : './assets/media/icons/duotune/general/gen061.svg';
  }
}
